import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { LanguageGuard } from '@guards/language.guard';
import { RoleGuard } from '@guards/role.guard';
import { CustomPreloading } from './extensions/custom-preloading';

const routes: Routes = [
  {
    path: '',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
    data: {
      title: 'seo.page.home.title',
      description: 'seo.page.home.description',
      preload: true
    },
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    redirectTo: ''
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, RoleGuard, LanguageGuard],
    loadChildren: () =>
      import('./pages/admin/admin.module').then((m) => m.AdminModule),
    data: {
      title: 'Administration Panel',
      description: '',
      robots: 'noindex,nofollow',
      preload: false
    }
  },
  {
    path: 'auth',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthModule),
    data: {
      title: 'seo.page.auth.title',
      description: 'seo.page.auth.description',
      preload: false
    }
  },
  {
    path: 'register',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/register/register.module').then((m) => m.RegisterModule),
    data: {
      title: 'seo.page.register.title',
      description: 'seo.page.register.description',
      preload: false
    }
  },
  {
    path: 'login',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
    data: {
      title: 'seo.page.login.title',
      description: 'seo.page.login.description',
      preload: false
    }
  },
  {
    path: 'changepassword',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/change-password/change-password.module').then((m) => m.ChangePasswordModule),
    data: {
      title: 'seo.page.changepassword.title',
      description: 'seo.page.changepassword.description',
      preload: false
    }
  },
  {
    path: 'forgotpassword',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
    data: {
      title: 'seo.page.forgotpassword.title',
      description: 'seo.page.forgotpassword.description',
      preload: false
    }
  },
  {
    path: 'user',
    canActivate: [AuthGuard, LanguageGuard],
    loadChildren: () =>
      import('./pages/user/user.module').then((m) => m.UserModule),
    data: {
      title:'Dashboard',
      robots: 'noindex,nofollow',
      preload: false
    }
  },
  {
    path: 'search/:phrase',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/search/search.module').then((m) => m.SearchModule),
    data: {
      title: 'Search Result',
      preload: false
    }
  },
  {
    path: 'search',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/search/search.module').then((m) => m.SearchModule),
    data: {
      title: 'Search',
      description: '',
      preload: false
    },
  },
  {
    path: 'membership',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/membership/membership.module').then((m) => m.MembershipModule),
    data: {
      title: 'seo.page.membership.title',
      description: 'seo.page.membership.description',
      preload: false
    }
  },
  {
    path: 'services',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/services/services.module').then((m) => m.ServicesModule),
    data: {
      title: 'seo.page.services.title',
      description: 'seo.page.services.description',
      preload: false
    }
  },
  {
    path: 'learning',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/learning/learning.module').then((m) => m.LearningModule),
    data: {
      title: 'seo.page.learning.title',
      description: 'seo.page.learning.description',
      preload: false
    }
  },
  {
    path: 'fundingopportunities',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/funding-opportunities/funding-opportunities.module').then((m) => m.FundingOpportunitiesModule),
    data: {
      title: 'seo.page.opportunities.title',
      description: 'seo.page.opportunities.description',
      preload: false
    }
  },
  {
    path: 'recruitment',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/recruitment/recruitment.module').then((m) => m.RecruitmentModule),
    data: {
      title: 'seo.page.recruitment.title',
      description: 'seo.page.recruitment.description',
      preload: false
    }
  },
  {
    path: 'jobs',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/jobs/jobs.module').then((m) => m.JobsModule),
    data: {
      title: 'seo.page.jobs.title',
      description: 'seo.page.jobs.description',
      preload: false
    }
  },
  {
    path: 'blog',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/blog/blog.module').then((m) => m.BlogModule),
    data: {
      title: 'seo.page.blog.title',
      description: 'seo.page.blog.description',
      preload: false
    }
  },
  {
    path: 'contactform',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/contact-form/contact-form.module').then((m) => m.ContactFormModule),
    data: {
      title: 'seo.page.contactform.title',
      description: 'seo.page.contactform.description',
      preload: false
    }
  },
  {
    path: 'newsletter',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/newsletter/newsletter.module').then((m) => m.NewsletterModule),
    data: {
      title: 'seo.page.newsletter.title',
      description: 'seo.page.newsletter.description',
      preload: false
    }
  },
  {
    path: 'delete-my-data',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/delete-my-data/delete-my-data.module').then((m) => m.DeleteMyDataModule),
    data: {
      title: 'Delete my Data',
      description: '',
      preload: false
    }
  },
  {
    path: 'privacy-policy',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
    data: {
      title: 'seo.page.privacyPolicy.title',
      description: 'seo.page.privacyPolicy.description',
      preload: false
    }
  },
  {
    path: 'cookie-policy',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/cookie-policy/cookie-policy.module').then((m) => m.CookiePolicyModule),
    data: {
      title: 'seo.page.cookiePolicy.title',
      description: 'seo.page.cookiePolicy.description',
      preload: false
    }
  },
  {
    path: 'legal-notice',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/legal-notice/legal-notice.module').then((m) => m.LegalNoticeModule),
    data: {
      title: 'seo.page.legalNotice.title',
      description: 'seo.page.legalNotice.description',
      preload: false
    }
  },
  {
    path: 'terms-and-conditions',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/terms-and-conditions/terms-and-conditions.module').then((m) => m.TermsAndConditionsModule),
    data: {
      title: 'seo.page.termsAndConditions.title',
      description: 'seo.page.termsAndConditions.description',
      preload: false
    }
  },
  {
    path: 'summit2024',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/events/summit-2024/summit-2024.module').then((m) => m.Summit2024Module),
    data: {
      title: 'seo.page.summit.title',
      description: 'seo.page.summit.description',
      preload: false
    }
  },
  {
    path: 'summit2025',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/events/summit-2025/summit-2025.module').then((m) => m.Summit2025Module),
    data: {
      title: 'seo.page.summit2025.title',
      description: 'seo.page.summit2025.description',
      preload: false
    }
  },
  {
    path: 'summit2026',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./pages/events/summit-2026/summit-2026.module').then((m) => m.Summit2026Module),
    data: {
      title: 'seo.page.summit2026.title',
      description: 'seo.page.summit2026.description',
      preload: false
    }
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: CustomPreloading,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      useHash: false
    })
  ],
  exports: [RouterModule],
  providers: [CustomPreloading],
})
export class AppRoutingModule {}
